var map = {
	"./refund-success@3x.png": 2082,
	"./reject-refund@3x.png": 2083
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 594;


//////////////////
// WEBPACK FOOTER
// ./src/images/refund ^\.\/.*\.png$
// module id = 594
// module chunks = 6